<template>
    <div id="translations"><slot></slot></div>
</template>
<script>
import { mapActions } from "vuex";
import messages from "@/../static/mocks/i18n";
import cacheService from "@/services/cache";

export default {
    methods: {
        ...mapActions("i18n", ["setLangs"])
    },
    created() {
        const rem3rchUser = cacheService.getRem3rchUser();
        const currentLangs = rem3rchUser && rem3rchUser.user && rem3rchUser.user.languages;

        if (currentLangs) {
            console.assert(Array.isArray(currentLangs));
            const res = currentLangs.map(lang => ({
                label: messages[lang.code].trad,
                value: lang.code,
                id: lang.id
            }));
            this.setLangs(res);
        }
    }
};
</script>

<style lang="scss" scoped>
#translations {
    display: flex;
    flex-direction: column;
    flex: 1 1 auto;
    width: 100%;
    height: 100%;
}
</style>



// WEBPACK FOOTER //
// translations.vue?07035cf9